import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { BASKET_DEAL_PRODUCT_MERCHANT_AMOUNT } from '../../brands/default/content/components/checkout';
import { formatCurrency } from '../../helpers/currency';
import ThemeContext from '../../providers/ThemeProvider';

export default function BasketDealProductMerchantAmount({ deal, product }) {
  const theme = useContext(ThemeContext);
  const show =
    product.payDeposit && product.depositProduct && product.totalMerchantAmount;

  if (!show) {
    return null;
  }

  return (
    <>
      <div className="product__merchant">
        <p className="product__merchant-amount">
          <strong>
            {formatCurrency(
              deal?.currency,
              product.totalMerchantAmount,
              true,
              false,
            )}
          </strong>{' '}
          {BASKET_DEAL_PRODUCT_MERCHANT_AMOUNT.depositPayToMerchant}
        </p>
      </div>
      <style jsx>{`
        .product__merchant {
          margin-top: 5px;
        }
        .product__merchant-amount {
          font-size: 12px;
          text-align: right;
          margin-bottom: 0;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .product__merchant-amount {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
}

BasketDealProductMerchantAmount.propTypes = {
  deal: PropTypes.object,
  product: PropTypes.object,
};
